



  <div *ngIf="phoneApp">
    <div class="daPic">
      <div style="text-align: center">
        <div class="titleFont" style="padding-top: 40%; color:white;font-size: 30px; padding-left: 0">Booking Inquiry </div>
      </div>
      <table style="width: 100%; height: 100%; padding-top: 1%; margin: 0px">
        <tr>
          <td  >
            <table  class="table-fill" style="height: 100%; text-align: center">
              <tr>
                <td style="vertical-align: top;">
                  <div>
                    <mat-card class="speech-bubble3" style="text-align: center;background-color: rgba(238,238,237,1); " xmlns="http://www.w3.org/1999/html">
                      <div class="lowerCaseLetters" style="font-size: 14px;text-align: left; padding-left: 5%;padding-bottom: 1px; padding-top: 5px ">Booking Number</div>
                      <mat-form-field class="newField " style="font-size: 17px; min-width: 90%; max-width: 90%; padding: 10px" appearance="outline" >
                        <input  [(ngModel)]="txtFromArea"   matInput  oninput="this.value = this.value.toUpperCase()">
                        <mat-icon (click)="getSearchItems()" matSuffix><img style="vertical-align: center;" src="assets/search.svg" ></mat-icon>

                      </mat-form-field>
                      <div style="text-align: center; padding-top: 5px; padding-bottom: 4px">
                        <div class="errorDiv2"  *ngIf="submitted && didntEnterShit">Please Enter A Value</div>
                        <div class="errorDiv2"  *ngIf="submitted && maherError!=null">{{maherError}}</div>
                      </div>


                    </mat-card>
                  </div>

                  <div *ngIf="showDetailScreen">


                    <div style="padding-top: 8%">
                      <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">
                        <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="booking"></div>
                        </div>
                        <div style="text-align: -webkit-center">
                          <div class="lowerCaseLetters" style=" font-size: 14px;">Booking Information</div>
                        </div>

                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Line Op</mat-label>
                          <input [(ngModel)]="bookDetail.line_id_description" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Hazardous</mat-label>
                          <input [(ngModel)]="bookDetail.hazardousFmt" matInput readonly/>
                        </mat-form-field>
                        <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                          <mat-label style="font-size: 20px; color: #E61E00">Reefers</mat-label>
                          <input [(ngModel)]="bookDetail.reeferFmt" matInput readonly/>
                        </mat-form-field>
                      </mat-card>
                    </div>



                  <div style="padding-top: 8%">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7); " label="Vessel Information" xmlns="http://www.w3.org/1999/html">

                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="vessel"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; ">Vessel Information</div>
                      </div>


                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Vessel</mat-label>
                        <input [(ngModel)]="bookDetail.vessel_description" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Voyage</mat-label>
                        <input [(ngModel)]="bookDetail.ob_vyg" matInput readonly/>
                      </mat-form-field>
                      </mat-card>
                  </div>


                  <div style="padding-top: 8%">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">
                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="clock"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px;">Vessel Times</div>
                      </div>

                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">ETA</mat-label>
                        <input [(ngModel)]="bookDetail.eta_fmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Begin Auto Receive</mat-label>
                        <input [(ngModel)]="bookDetail.begin_auto_receive_fmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field  class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Auto Cutoff</mat-label>
                        <input [(ngModel)]="bookDetail.auto_cutoff_fmt"  matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline" style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Begin Receive</mat-label>
                        <input  [(ngModel)]="bookDetail.begin_receive_fmt"  matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline" style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Cargo Cutoff</mat-label>
                        <input  [(ngModel)]="bookDetail.cargo_cutoff_fmt"  matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>



                  <div style="padding-top: 8%">
                    <mat-card class="iso-bubble"  style="text-align: center;background-color: rgba(238,238,237,0.7); " xmlns="http://www.w3.org/1999/html">

                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="stacked"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px;">Authorizations</div>
                      </div>

                      <div class="flex-item2" >
                        <mat-table #table4 [dataSource]="itemsData2" multiTemplateDataRows matSort="container" >
                          <ng-container matColumnDef="description2" >
                            <mat-header-cell *matHeaderCellDef  class="myHeader">ISO</mat-header-cell>
                            <mat-cell *matCellDef="let row" style="flex: 0 0 60% !important; font-weight: bolder;">{{row.description}}</mat-cell>
                          </ng-container>
                          <ng-container matColumnDef="qty" >
                            <mat-header-cell *matHeaderCellDef  class="myHeader">Qty</mat-header-cell>
                            <mat-cell *matCellDef="let row" style="flex: 0 0 11.3% !important;">{{row.qty}}</mat-cell>
                          </ng-container>
                          <ng-container matColumnDef="delivered_qty" >
                            <mat-header-cell *matHeaderCellDef  class="myHeader">Delv</mat-header-cell>
                            <mat-cell *matCellDef="let row" style="flex: 0 0 11% !important;">{{row.delivered_qty}}</mat-cell>
                          </ng-container>
                          <ng-container matColumnDef="received_qty">
                            <mat-header-cell *matHeaderCellDef  class="myHeader">Recv</mat-header-cell>
                            <mat-cell *matCellDef="let row" style="flex: 0 0 11.1% !important;">{{row.received_qty}}</mat-cell>
                          </ng-container>
                          <mat-header-row *matHeaderRowDef="authColumns2; sticky: true"></mat-header-row>
                          <mat-row   *matRowDef="let row; columns: authColumns2;" class="table-row"></mat-row>
                        </mat-table>
                      </div>
                    </mat-card>
                  </div>
                  </div>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>


  </div>




  <table class="mainTable" style="width: 100%">
    <tr>
      <td class="mainUpperTd">
        <mat-card class="quickView" *ngIf="showQuickView">
          <table style="width: 100%; border-collapse: collapse;margin: 0px; padding: 0px">
            <tr>
              <td style="width: 18%">
                <div class="maher" (click)="myApp.showCharts()"></div>
              </td>
              <td style="width: 70%">
                <div >
                  <mat-form-field class="search"  appearance="outline">
                    <mat-label style="padding-left: 20px;">Search by Any Available Columns</mat-label>
                    <mat-icon matPrefix ><img style="vertical-align: center;height:25px; width: 25px" src="assets/booking.png" ></mat-icon>
                    <input  maxlength="30" style="padding-left: 20px;"  matInput (keyup)="applyFilter($event.target.value)"  [formControl]="search1">
                  </mat-form-field>
                </div>
                <div class="lowerCaseLetters" style="font-size: 14px; padding-left: 24%">Click On Any Row To View Details For The Booking</div>
              </td>
              <td style="width: 20%" *ngIf="ipadApp">
                <div >
                  <div class="lowerCaseLetters" *ngIf="this.ipadApp" (click)="returnToSearch()" style="font-size: 14px; color: #E61E00; cursor: pointer">Back To Search</div>
                </div>
              </td>
            </tr>
          </table>

          <div class="flex-item2" >
            <mat-table #table [dataSource]="quickViewData" multiTemplateDataRows matSort="container" >
              <ng-container matColumnDef="booking" >
                <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Booking</mat-header-cell>
                <mat-cell *matCellDef="let row" style="flex: 0 0 10% !important;">{{row.booking}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="line_id" >
                <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Line Op</mat-header-cell>
                <mat-cell *matCellDef="let row" style="flex: 0 0 4% !important;">{{row.line_id}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="booking_type" >
                <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Type</mat-header-cell>
                <mat-cell *matCellDef="let row" style="flex: 0 0 4% !important;">{{row.booking_type}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="vesVoyage" >
                <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Vessel/Voyage</mat-header-cell>
                <mat-cell *matCellDef="let row" style="flex: 0 0 18% !important;">{{row.vesVoyage}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="vessel_visit_phase_description" >
                <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Phase</mat-header-cell>
                <mat-cell *matCellDef="let row" style="flex: 0 0 7% !important;" [className]="row.vessel_visit_phase >= '50' ? 'redColor' : 'greenColor'">{{row.vessel_visit_phase_description}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="quantity">
                <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Qty</mat-header-cell>
                <mat-cell *matCellDef="let row" style="flex: 0 0 6% !important;">{{row.quantity}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="tally_in" >
                <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">{{tallyInDisp}}</mat-header-cell>
                <mat-cell *matCellDef="let row" style="flex: 0 0 5% !important;">{{row.tally_in}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="tally_out" >
                <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">{{tallyOutDisp}}</mat-header-cell>
                <mat-cell *matCellDef="let row" style="flex: 0 0 6% !important;">{{row.tally_out}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="receive_completeFmt" >
                <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">{{recColName}}</mat-header-cell>
                <mat-cell *matCellDef="let row" style="flex: 0 0 7.3% !important;">{{row.receive_completeFmt}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="deliver_completeFmt" >
                <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">{{delColName}}</mat-header-cell>
                <mat-cell *matCellDef="let row" style="flex: 0 0 7% !important;">{{row.deliver_completeFmt}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="hazardousFmt" >
                <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Haz.</mat-header-cell>
                <mat-cell *matCellDef="let row" style="flex: 0 0 4.2% !important;">{{row.hazardousFmt}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="reeferFmt" >
                <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Reef.</mat-header-cell>
                <mat-cell *matCellDef="let row" style="flex: 0 0 4.3% !important;">{{row.reeferFmt}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="created_date_fmt" >
                <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Created</mat-header-cell>
                <mat-cell *matCellDef="let row">{{row.created_date_fmt}}</mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="qvColumns; sticky: true"></mat-header-row>
              <mat-row   *matRowDef="let row; columns: qvColumns;" class="table-row" (click)="showDetails(row)"></mat-row>
            </mat-table>
            <mat-toolbar style="width: 100%; display: unset">
              <mat-toolbar-row style="width: 100%; ">
                <mat-paginator class="myPaginator" (touchstart)="dontShowSearch()"  [pageSize]="20" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
                  <span style="padding-left: 24%">
                  <button mat-raised-button matTooltip="Export To Excel"  (click)="exportExcel()"><img style="height: 38px"  src="assets/excel.png" ></button>
                    </span>
              </mat-toolbar-row>
            </mat-toolbar>
          </div>

        </mat-card>

        <mat-card class="details" *ngIf="showDetailScreen">
          <table style="width: 100%; height: 100%">
            <tr>
              <td class="upperTd">


                <mat-card class="contDetails">
                  <table style="width: 100%">
                    <tr>
                      <div class="maher2" (click)="myApp.showCharts()"></div>
                      <td style="width: 13%">
                        <div class="titleFont" style="font-size: 23px">Booking Details</div>
                      </td>
                      <td style="width: 25%">
                        <div class="titleFont" style="padding-left: 3%; font-size: 23px">Booking:<a style="color: green"> {{bookDetail.booking}}</a></div>
                      </td>
                      <td style="width: 25%">
                        <div class="titleFont" style="padding-left: 3%; font-size: 23px">Line Op:<a style="color: green"> {{bookDetail.line_id_description}}</a></div>
                      </td>
                      <td style="width: 21%">
                        <div class="titleFont" style="padding-left: 3%; font-size: 23px;">Type: <a style="color: green">{{bookDetail.booking_type}}</a></div>
                      </td>
                      <td style="width: 15%" *ngIf="bookDetails.length>1">
                        <div class="lowerCaseLetters"  (click)="returnToQuickView()" style="font-size: 14px; color: #E61E00; cursor: pointer">Back To Quick View</div>
                      </td>
                      <td style="width: 21%" *ngIf="bookDetails.length==1 && this.ipadApp">
                        <div class="lowerCaseLetters"  (click)="returnToQuery()" style="font-size: 14px; color: #E61E00; cursor: pointer">Back To Search</div>
                      </td>
                    </tr>
                  </table>



                  <table style="width: 100%; height: 100%; padding: 0px; margin: 0px">
                    <tr>
                      <td style="width: 85%; height: 100%; text-align: center;" >
                        <table  class="table-fill" style="height: 100%">
                          <tr>



                            <td style="vertical-align: top" *ngIf="bookDetail.booking_type=='BOOK'">
                              <div style="background-color: rgba(238,238,237,0.7); border: #E61E00 1px solid; height: 100%">

                                <div >
                                  <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Vessel Info</div>

                                  <div style="padding-top: 2px">
                                    <mat-form-field appearance="outline">
                                      <mat-label style="font-size: 18px; color: #E61E00">Vessel</mat-label>
                                      <input [(ngModel)]="bookDetail.vessel_description"  matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline" >
                                      <mat-label style="font-size: 18px; color: #E61E00">Voyage</mat-label>
                                      <input [(ngModel)]="bookDetail.ob_vyg" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline" >
                                      <mat-label style="font-size: 18px; color: #E61E00">Port of Loading</mat-label>
                                      <input [(ngModel)]="bookDetail.port_of_loading_description" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline" >
                                      <mat-label style="font-size: 18px; color: #E61E00">Port of Discharge</mat-label>
                                      <input [(ngModel)]="bookDetail.port_of_discharge_description" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline" >
                                      <mat-label style="font-size: 18px; color: #E61E00">Port of Destination</mat-label>
                                      <input [(ngModel)]="bookDetail.port_of_destination_description" matInput readonly/>
                                    </mat-form-field>
                                  </div>


                                </div>
                              </div>
                            </td>

                            <td *ngIf="bookDetail.booking_type=='BOOK'" style="vertical-align: top" style="background-color:rgba(23,122,241,0.07); border: #E61E00 1px solid; height: 100%; vertical-align: top" >

                              <div>
                                <div  class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Vessel Times</div>
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">ETA</mat-label>
                                    <input [(ngModel)]="bookDetail.eta_fmt"  matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Begin Auto Receive</mat-label>
                                    <input  [(ngModel)]="bookDetail.begin_auto_receive_fmt"  matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div >
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Auto Cutoff</mat-label>
                                    <input *ngIf="isBeforeToday(bookDetail.auto_cutoff)" class="redColorText" [(ngModel)]="bookDetail.auto_cutoff_fmt"  matInput readonly/>
                                    <input *ngIf="!isBeforeToday(bookDetail.auto_cutoff)"  [(ngModel)]="bookDetail.auto_cutoff_fmt"  matInput readonly/>
                                  </mat-form-field>
                                </div>

                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Begin Receive</mat-label>
                                    <input   [(ngModel)]="bookDetail.begin_receive_fmt"  matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Cargo Cutoff</mat-label>
                                    <input *ngIf="isBeforeToday(bookDetail.cargo_cutoff)" class="redColorText" [(ngModel)]="bookDetail.cargo_cutoff_fmt"  matInput readonly/>
                                    <input *ngIf="!isBeforeToday(bookDetail.cargo_cutoff)"  [(ngModel)]="bookDetail.cargo_cutoff_fmt"  matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div >
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Hazardous Cutoff</mat-label>
                                    <input *ngIf="isBeforeToday(bookDetail.hazardous_cutoff)" class="redColorText" [(ngModel)]="bookDetail.hazardous_cutoff_fmt"  matInput readonly/>
                                    <input *ngIf="!isBeforeToday(bookDetail.hazardous_cutoff)"  [(ngModel)]="bookDetail.hazardous_cutoff_fmt"  matInput readonly/>
                                  </mat-form-field>
                                </div>
                              </div>
                            </td>

                            <td style="vertical-align: top" [className]="bookDetail.booking_type == 'BOOK' ? 'lightGrey' : 'lightBlue'">
                              <div style="height: 100%">

                                <div >
                                  <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Booking Info</div>

                                  <div>
                                    <mat-form-field appearance="outline" >
                                      <mat-label style="font-size: 18px; color: #E61E00">Notes</mat-label>
                                      <textarea style="max-height: 40px; min-height: 40px" [(ngModel)]="bookDetail.notes" matInput readonly></textarea>
                                    </mat-form-field>
                                  </div>

                                  <div style="padding-top: 2px">
                                    <mat-form-field appearance="outline">
                                      <mat-label style="font-size: 18px; color: #E61E00">Hazardous</mat-label>
                                      <input [(ngModel)]="bookDetail.hazardousFmt"  matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline" >
                                      <mat-label style="font-size: 18px; color: #E61E00">Reefers</mat-label>
                                      <input [(ngModel)]="bookDetail.reeferFmt" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div *ngIf="myUser.role=='LINEOP' || myUser.canSeeAllData=='1'">
                                    <mat-form-field appearance="outline" >
                                      <mat-label style="font-size: 18px; color: #E61E00">Shipper</mat-label>
                                      <input [(ngModel)]="bookDetail.shipper" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div *ngIf="myUser.role=='LINEOP' || myUser.canSeeAllData=='1'">
                                    <mat-form-field appearance="outline" >
                                      <mat-label style="font-size: 18px; color: #E61E00">Consignee</mat-label>
                                      <input [(ngModel)]="bookDetail.consignee" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                </div>
                              </div>
                            </td>

                            <td *ngIf="myUser.role=='HAULIER' && bookDetail.utcsView!=null " style="vertical-align: top" [className]="bookDetail.booking_type == 'BOOK' ? 'lightBlue' : 'lightGrey'">

                              <div>
                                <div  class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Trucker Information</div>
                                <div >
                                  <mat-form-field appearance="outline">
                                    <mat-label style="font-size: 18px; color: #E61E00">Trucker</mat-label>
                                    <input  [(ngModel)]="bookDetail.utcsView.truckername" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Trucker Status</mat-label>
                                    <input *ngIf="bookDetail.utcsView.trucklinestatus.toUpperCase()=='BANNED'" class="redColorText"  [(ngModel)]="bookDetail.utcsView.trucklinestatus" matInput readonly/>
                                    <input *ngIf="bookDetail.utcsView.trucklinestatus.toUpperCase()!='BANNED'" [(ngModel)]="bookDetail.utcsView.trucklinestatus" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Account Status</mat-label>
                                    <input *ngIf="bookDetail.utcsView.lifecyclestatedescription.toUpperCase()=='BANNED'" class="redColorText"  [(ngModel)]="bookDetail.utcsView.lifecyclestatedescription" matInput readonly/>
                                    <input *ngIf="bookDetail.utcsView.lifecyclestatedescription.toUpperCase()!='BANNED'" [(ngModel)]="bookDetail.utcsView.lifecyclestatedescription" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Insurance Expiration</mat-label>
                                    <input *ngIf="isBeforeToday(bookDetail.utcsView.insuranceexpirationdate)" class="redColorText" [(ngModel)]="bookDetail.utcsView.insuranceexpirationdate_fmt"  matInput readonly/>
                                    <input *ngIf="!isBeforeToday(bookDetail.utcsView.insuranceexpirationdate)"  [(ngModel)]="bookDetail.utcsView.insuranceexpirationdate_fmt"  matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Credit Expiration</mat-label>
                                    <input *ngIf="isBeforeToday(bookDetail.utcsView.creditexpirationdate)" class="redColorText" [(ngModel)]="bookDetail.utcsView.creditexpirationdate_fmt"  matInput readonly/>
                                    <input *ngIf="!isBeforeToday(bookDetail.utcsView.creditexpirationdate)"  [(ngModel)]="bookDetail.utcsView.creditexpirationdate_fmt"  matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Expiration Date</mat-label>
                                    <input [(ngModel)]="bookDetail.utcsView.expirationdate_fmt" matInput readonly/>
                                  </mat-form-field>
                                </div>
                              </div>
                            </td>


                            <td style="vertical-align: top">
                              <div [className]="myUser.role == 'HAULIER' && bookDetail.booking_type=='BOOK' ? 'lightGrey' : myUser.role=='HAULIER' ? 'lightGrey': 'lightBlue'">
                                <div >
                                  <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Auditing Information</div>
                                  <div>
                                    <mat-form-field appearance="outline" floatLabel="always">
                                      <mat-label style="font-size: 18px; color: #E61E00">Created</mat-label>
                                      <input [(ngModel)]="bookDetail.created_date_fmt" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline" floatLabel="always">
                                      <mat-label style="font-size: 18px; color: #E61E00">Created By</mat-label>
                                      <input [(ngModel)]="bookDetail.created_by" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline" floatLabel="always">
                                      <mat-label style="font-size: 18px; color: #E61E00">Changed</mat-label>
                                      <input [(ngModel)]="bookDetail.changed_date_fmt" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                  <div>
                                    <mat-form-field appearance="outline" floatLabel="always" >
                                      <mat-label style="font-size: 18px; color: #E61E00">Changed By</mat-label>
                                      <input [(ngModel)]="bookDetail.changed_by" matInput readonly/>
                                    </mat-form-field>
                                  </div>
                                </div>

                              </div>
                            </td>
                          </tr>


                          <tr>
                            <td style="vertical-align: top" colspan="5" *ngIf="myUser.role=='LINEOP' && bookDetail.hazardous=='1'">
                              <div class="lightSand">
                                <div >
                                  <table style="width: 100%">
                                    <tr>
                                      <td style="width: 80%">
                                        <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 2%;padding-bottom: 15px ">Hazardous Information</div>
                                      </td>
                                      <td style="width: 10%" >
                                        <div class="lowerCaseLetters" [hidden]="bookDetail.bookingHazardsViews.length==1" (click)="previousHazard()"  style="font-size: 14px; color: #E61E00; cursor: pointer">Previous Hazard</div>
                                      </td>
                                      <td style="width: 10%" >
                                        <div class="lowerCaseLetters" [hidden]="bookDetail.bookingHazardsViews.length==1" (click)="nextHazard()" style="font-size: 14px; color: #E61E00; cursor: pointer">Next Hazard</div>
                                      </td>
                                    </tr>
                                  </table>

                                  <table style="width: 100%">
                                    <tr>
                                      <td>
                                        <div>
                                          <mat-form-field appearance="outline"  floatLabel="always">
                                            <mat-label style="font-size: 18px; color: #E61E00">IMDG Class</mat-label>
                                            <input [(ngModel)]="bookHaz.imdgConcat" matInput readonly/>
                                          </mat-form-field>
                                        </div>
                                        <div>
                                          <mat-form-field appearance="outline" floatLabel="always">
                                            <mat-label style="font-size: 18px; color: #E61E00">UNDG</mat-label>
                                            <input [(ngModel)]="bookHaz.undgTypeConcat" matInput readonly/>
                                          </mat-form-field>
                                        </div>
                                        <div>
                                          <mat-form-field appearance="outline" floatLabel="always">
                                            <mat-label style="font-size: 18px; color: #E61E00">Quantity</mat-label>
                                            <input [(ngModel)]="bookHaz.quantity" matInput readonly/>
                                          </mat-form-field>
                                        </div>
                                      </td>

                                      <td>
                                        <div>
                                          <mat-form-field appearance="outline" floatLabel="always">
                                            <mat-label style="font-size: 18px; color: #E61E00">Technical Name</mat-label>
                                            <input [(ngModel)]="bookHaz.techname" matInput readonly/>
                                          </mat-form-field>
                                        </div>
                                        <div>
                                          <mat-form-field appearance="outline" floatLabel="always" >
                                            <mat-label style="font-size: 18px; color: #E61E00">Proper Name</mat-label>
                                            <input [(ngModel)]="bookHaz.proper_name" matInput readonly/>
                                          </mat-form-field>
                                        </div>
                                        <div>
                                          <mat-form-field appearance="outline" floatLabel="always">
                                            <mat-label style="font-size: 18px; color: #E61E00">Notes</mat-label>
                                            <input [(ngModel)]="bookHaz.remarks" matInput readonly/>
                                          </mat-form-field>
                                        </div>
                                      </td>


                                      <td>
                                        <div>
                                          <mat-form-field appearance="outline" floatLabel="always">
                                            <mat-label style="font-size: 18px; color: #E61E00">Package Type</mat-label>
                                            <input [(ngModel)]="bookHaz.packagetype" matInput readonly/>
                                          </mat-form-field>
                                        </div>
                                        <div>
                                          <mat-form-field appearance="outline" floatLabel="always">
                                            <mat-label style="font-size: 18px; color: #E61E00">Package Group</mat-label>
                                            <input [(ngModel)]="bookHaz.packagegroup" matInput readonly/>
                                          </mat-form-field>
                                        </div>
                                        <div>
                                          <mat-form-field appearance="outline" floatLabel="always">
                                            <mat-label style="font-size: 18px; color: #E61E00">Weight</mat-label>
                                            <input [(ngModel)]="bookHaz.weight_fmt" matInput readonly/>
                                          </mat-form-field>
                                        </div>

                                      </td>
                                      <td>
                                        <div>
                                          <mat-form-field appearance="outline" floatLabel="always">
                                            <mat-label style="font-size: 18px; color: #E61E00">FlashPoint</mat-label>
                                            <input [(ngModel)]="bookHaz.flashpoint" matInput readonly/>
                                          </mat-form-field>
                                        </div>
                                        <div>
                                          <mat-form-field appearance="outline" floatLabel="always">
                                            <mat-label style="font-size: 18px; color: #E61E00">Emergency Phone</mat-label>
                                            <input [(ngModel)]="bookHaz.emergency_telephone_fmt" matInput readonly/>
                                          </mat-form-field>
                                        </div>
                                        <div>
                                          <mat-form-field appearance="outline" floatLabel="always">
                                            <mat-label style="font-size: 18px; color: #E61E00">Marine Pollutants</mat-label>
                                            <input [(ngModel)]="bookHaz.marinepollutantFmt" matInput readonly/>
                                          </mat-form-field>
                                        </div>
                                      </td>
                                    </tr>

                                  </table>


                                </div>

                              </div>
                            </td>



                          </tr>

                          <tr>
                            <td colspan="5">
                              <table style="width: 100%">
                                <tr>
                                  <td style="width: 75%">
                                    <div class="lowerCaseLetters" style="font-size: 13px; padding-left: 20%; text-align: center;">Click On Authorization For More Details</div>
                                  </td>
                                  <td style="width: 12%" >
                                    <div class="lowerCaseLetters" [hidden]="bookDetails.length==1" (click)="previousTransaction()" style="font-size: 14px; color: #E61E00; cursor: pointer">Previous Booking</div>
                                  </td>
                                  <td style="width: 10%" >
                                    <div class="lowerCaseLetters" [hidden]="bookDetails.length==1" (click)="nextTransaction()" style="font-size: 14px; color: #E61E00; cursor: pointer">Next Booking</div>
                                  </td>
                                </tr>
                              </table>
                            </td>

                          </tr>


                          <tr>
                            <td colspan="5">
                              <div class="flex-item4" >
                                <mat-table #table2 [dataSource]="itemsData" multiTemplateDataRows matSort="container" >
                                  <ng-container matColumnDef="description" >
                                    <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">ISO</mat-header-cell>
                                    <mat-cell *matCellDef="let row" style="flex: 0 0 14% !important;">{{row.description}}</mat-cell>
                                  </ng-container>
                                  <ng-container matColumnDef="grade_description" >
                                    <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Grade</mat-header-cell>
                                    <mat-cell *matCellDef="let row" style="flex: 0 0 14% !important;">{{row.grade_description}}</mat-cell>
                                  </ng-container>
                                  <ng-container matColumnDef="qty" >
                                    <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Quantity</mat-header-cell>
                                    <mat-cell *matCellDef="let row" style="flex: 0 0 10.1% !important;">{{row.qty}}</mat-cell>
                                  </ng-container>
                                  <ng-container matColumnDef="delivered_qty" >
                                    <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Delivered</mat-header-cell>
                                    <mat-cell *matCellDef="let row" style="flex: 0 0 10% !important;">{{row.delivered_qty}}</mat-cell>
                                  </ng-container>
                                  <ng-container matColumnDef="delivered_balance" >
                                    <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Delv. Bal.</mat-header-cell>
                                    <mat-cell *matCellDef="let row" style="flex: 0 0 10% !important;">{{row.delivered_balance}}</mat-cell>
                                  </ng-container>
                                  <ng-container matColumnDef="rcv_limit" >
                                    <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Receive Limit</mat-header-cell>
                                    <mat-cell *matCellDef="let row" style="flex: 0 0 10.1% !important;">{{row.rcv_limit}}</mat-cell>
                                  </ng-container>
                                  <ng-container matColumnDef="received_qty">
                                    <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Received</mat-header-cell>
                                    <mat-cell *matCellDef="let row" style="flex: 0 0 10% !important;">{{row.received_qty}}</mat-cell>
                                  </ng-container>
                                  <ng-container matColumnDef="received_balance" >
                                    <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Recv. Bal.</mat-header-cell>
                                    <mat-cell *matCellDef="let row" style="flex: 0 0 10.1% !important;">{{row.received_balance}}</mat-cell>
                                  </ng-container>
                                  <ng-container matColumnDef="reservedCount" >
                                    <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Reserved</mat-header-cell>
                                    <mat-cell *matCellDef="let row" >{{row.reservedCount}}</mat-cell>
                                  </ng-container>



                                  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                                  <ng-container matColumnDef="expandedDetail" [attr.aria-colspan]="authColumns.length">
                                    <mat-cell class="newCell" *matCellDef="let row" >
                                      <div class="example-element-detail" [@detailExpand]="row == expandedElement ? 'expanded' : 'collapsed'">
                                        <table style="width: 100%">
                                          <tr>


                                            <td *ngIf="showReeferInfo"  style="vertical-align: top; width: 100%" style="background-color:rgba(238,238,237,0.7); border: #E61E00 1px solid; height: 100%; vertical-align: top" >
                                              <div>
                                                <div  class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Reefer Information</div>
                                                <div>
                                                  <mat-form-field appearance="outline" floatLabel="always">
                                                    <mat-label style="font-size: 18px; color: #E61E00">Temp Required</mat-label>
                                                    <input [(ngModel)]="row.temp_required_cFmt" matInput readonly/>
                                                  </mat-form-field>
                                                </div>
                                                <div>
                                                  <mat-form-field appearance="outline" floatLabel="always">
                                                    <mat-label style="font-size: 18px; color: #E61E00">Vent Required</mat-label>
                                                    <input [(ngModel)]="row.vent_required_pct" matInput readonly/>
                                                  </mat-form-field>
                                                </div>
                                                <div >
                                                  <mat-form-field appearance="outline" floatLabel="always">
                                                    <mat-label style="font-size: 18px; color: #E61E00">Vent Unit</mat-label>
                                                    <input [(ngModel)]="row.vent_unit_description" matInput readonly/>
                                                  </mat-form-field>
                                                </div>
                                                <div>
                                                  <mat-form-field appearance="outline" floatLabel="always">
                                                    <mat-label style="font-size: 18px; color: #E61E00">Humidity Required</mat-label>
                                                    <input [(ngModel)]="row.humidity_required" matInput readonly/>
                                                  </mat-form-field>
                                                </div>
                                              </div>
                                            </td>



                                            <td style="vertical-align: top; width: 100%" style="background-color:rgba(238,238,237,0.7); border: #E61E00 1px solid; height: 100%; vertical-align: top" >
                                              <div>
                                                <div  class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Audit Information</div>
                                                <div>
                                                  <mat-form-field appearance="outline" floatLabel="always">
                                                    <mat-label style="font-size: 18px; color: #E61E00">Created</mat-label>
                                                    <input [(ngModel)]="row.created_date_fmt" matInput readonly/>
                                                  </mat-form-field>
                                                </div>
                                                <div>
                                                  <mat-form-field appearance="outline" floatLabel="always">
                                                    <mat-label style="font-size: 18px; color: #E61E00">Created By</mat-label>
                                                    <input [(ngModel)]="row.created_by" matInput readonly/>
                                                  </mat-form-field>
                                                </div>
                                                <div >
                                                  <mat-form-field appearance="outline" floatLabel="always">
                                                    <mat-label style="font-size: 18px; color: #E61E00">Changed</mat-label>
                                                    <input [(ngModel)]="row.changed_date_fmt" matInput readonly/>
                                                  </mat-form-field>
                                                </div>
                                                <div>
                                                  <mat-form-field appearance="outline" floatLabel="always">
                                                    <mat-label style="font-size: 18px; color: #E61E00">Changed By</mat-label>
                                                    <input [(ngModel)]="row.changed_by" matInput readonly/>
                                                  </mat-form-field>
                                                </div>
                                              </div>
                                            </td>


                                            <td style="vertical-align: top; width: 100%" style="background-color:rgba(238,238,237,0.7); border: #E61E00 1px solid; height: 100%; vertical-align: top" >
                                              <div class="flex-item3" >
                                                <mat-table #table3 [dataSource]="unitData" multiTemplateDataRows matSort>
                                                  <ng-container matColumnDef="unit_id" >
                                                    <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 25% !important;" class="myHeader">Container</mat-header-cell>
                                                    <mat-cell *matCellDef="let row" style="flex: 0 0 25% !important;">{{row.unit_id}}</mat-cell>
                                                  </ng-container>
                                                  <ng-container matColumnDef="line_id" >
                                                    <mat-header-cell *matHeaderCellDef  style="flex: 0 0 15% !important;" mat-sort-header  class="myHeader">Line</mat-header-cell>
                                                    <mat-cell *matCellDef="let row" style="flex: 0 0 15% !important;">{{row.line_id}}</mat-cell>
                                                  </ng-container>
                                                  <ng-container matColumnDef="moveType" >
                                                    <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Move Type</mat-header-cell>
                                                    <mat-cell *matCellDef="let row" style="flex: 0 0 50% !important;">{{row.moveType}}</mat-cell>
                                                  </ng-container>
                                                  <mat-header-row *matHeaderRowDef="unitColumns; sticky: true"></mat-header-row>
                                                  <mat-row style="min-height: 17px;"   *matRowDef="let row; columns: unitColumns;" class="table-row"></mat-row>
                                                </mat-table>
                                              </div>
                                            </td>



                                          </tr>
                                        </table>

                                      </div>
                                    </mat-cell>
                                  </ng-container>


                                  <mat-header-row *matHeaderRowDef="authColumns; sticky: true"></mat-header-row>
                                  <mat-row *matRowDef="let row; columns: authColumns;"
                                           [className]="row.expanded == 'N'? 'example-element-row' : 'example-element-row2  expanded'"
                                           [class.example-expanded-row]="expandedElement === row"
                                           (click)="expandThatShit(row)">
                                  </mat-row>
                                  <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row" style="background-color: white"></mat-row>
                                </mat-table>
                                <mat-toolbar style="width: 100%; display: unset">
                                  <mat-toolbar-row style="width: 100%; ">
                                    <mat-paginator class="myPaginator"  [pageSize]="3" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
                                  </mat-toolbar-row>
                                </mat-toolbar>
                              </div>
                            </td>





                          </tr>


                        </table>
                      </td>
                    </tr>
                  </table>
                </mat-card>
              </td>
              <td class="loginPic" style="">

              </td>
            </tr>
          </table>

        </mat-card>

      </td>
      <td class="mainLowerTd" id="noPrint">
        <mat-card class="speech-bubble" *ngIf="ipadAppear">
          <div class="booking" style="margin-top: 2%;"></div>
          <div class="titleFont" style="padding-bottom: 10px;">Booking Inquiry </div>
          <div  class="lowerCaseLetters" style="font-size: 14px; text-align: center; padding-top: 5px">Enter Up To 100 Bookings</div>

          <div style="padding-left: 3%;">
            <mat-form-field class="newField" appearance="outline" >
              <textarea class="textarea" [(ngModel)]="txtFromArea"  matInput cdkTextareaAutosize oninput="this.value = this.value.toUpperCase()"></textarea>
            </mat-form-field>
            <div class="errorDiv2" style="text-align: center" *ngIf="didntEnterShit">Please Enter A Value</div>
            <div class="errorDiv2" style="text-align: center" *ngIf=" badChars">Invalid Character in {{bookingNum}}</div>
            <div class="errorDiv2" style="text-align: center" *ngIf=" badSearch">No Data Found</div>
            <div class="errorDiv2" style="text-align: center" *ngIf=" maherError!=null ">{{maherError}}</div>

          </div>

          <mat-toolbar mat-toolbar class="toolbar2">
            <mat-toolbar-row style="justify-content: center">
              <span style="padding-left: 20px"></span>
              <button mat-raised-button (click)="getSearchItems()"   class="blueButton" >Search</button>
              <span class="example-fill-remaining-space3"></span>

              <button mat-raised-button   class="redButton" (click)="wipeOutSearch()" >Clear List</button>

            </mat-toolbar-row>
          </mat-toolbar>
          <div>
            <mat-form-field class="myOption2"  appearance="outline">
              <mat-label>Saved Lists</mat-label>
              <mat-select  [(value)]="savedList" >
                <mat-option  *ngFor="let lr of savedLists" [value]="lr.id">{{lr.description}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <mat-toolbar class="myToolbar" >
            <mat-toolbar-row style="padding-left: 14%; height: 35px" >
              <button mat-button matTooltip="retrieve your saved list" (click)="showContainersFromList()" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/saved_search-24px.svg" ></button>
              <button mat-button matTooltip="update your saved list" (click)="updateContainerList('U')" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/save-24px.svg" ></button>
              <button mat-button matTooltip="delete your saved list" (click)="deleteHit()" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/delete-24px.svg" ></button>
            </mat-toolbar-row>
          </mat-toolbar>
          <mat-toolbar class="myToolbar" style="background-color: white">
            <mat-toolbar-row style="width: 76%">
              <mat-form-field  class="myOption" appearance="outline">
                <mat-label>New List</mat-label>
                <input maxlength="15" [(ngModel)]="myNewListName"  oninput="this.value = this.value.toUpperCase()" matInput/>
              </mat-form-field>
              <button mat-button matTooltip="create a new saved list" (click)="updateContainerList('I')" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/save-24px.svg" ></button>

            </mat-toolbar-row>
            <mat-toolbar-row style="height: 26px; justify-content: center">
              <div class="errorDiv2" style="text-align: center" *ngIf="submitted && insertListExists">List Exists For This User</div>
              <div class="errorDiv2" style="text-align: center" *ngIf="submitted && insertNoConts ">List Needs At Least 1 Booking</div>
              <div class="errorDiv2" style="text-align: center" *ngIf="submitted && noListName ">List Name Cannot Be Blank</div>
            </mat-toolbar-row>
          </mat-toolbar>

        </mat-card>
      </td>
    </tr>
  </table>











